module.exports = __webpack_public_path__ + "media/svg/sz-4e8fd08e.svg";